const riot = require('riot');

riot.tag2('page-index', '<div class="relative bg-main" ref="body"> <div class="container"> <div class="relative h100vh f fh mb64"> <div class="w200"><img class="rotate-4deg filter-invert object-fit-contain" src="/images/sign_text.PNG"></div> <div class="absolute b0 l0 r0 f fh text-center text-softgray opacity-100 transition cursor-pointer fs12 l-fs20" ref="scroll" onclick="{scrollToContents}"><span class="material-icons animation-shake-y animation-infinite">arrow_drop_down</span><span>scroll</span></div> </div> <div class="container f fclm fh py32 px64 s-pr16 ml32 s-ml0"> <div class="text-center lh20 mb32 opacity-0" data-reveal-class="fadein-bottom">Based on Tokyo, Japan<br>Dancer / Choreographer / Narrator / Model / Creator / Artist / KEMURI</div> <div class="w-full"> <video class="w-full" ref="video" riot-src="{videoSrc}" muted playsinline autoplay loop></video> </div> </div> <div class="px64 s-pr16 ml32 s-ml0" ref="contents"> <div class="row ft mxn16"> <div class="col6 s-col12 px16"> <div class="relative f fh flex-column py32 opacity-0" data-reveal-class="fadein-bottom"> <h2 class="mb16 w-full text-right fs32">NEWS</h2> <div class="w-full box-shadow" data-is="module-news" news="{news}"></div> </div> </div> <div class="col6 s-col12 px16"> <div class="relative f fh flex-column py32 opacity-0 transition2048" data-reveal-class="fadein-bottom"> <h2 class="mb16 w-full text-right fs32">LESSON</h2> <div class="w-full box-shadow" if="{lessons}" data-is="module-lessons" lessons="{lessons}"></div> </div> </div> </div> <div class="relative s-full f fh flex-column py32 opacity-0" data-reveal-class="fadein-bottom"> <h2 class="mb16 w-full text-right fs32">INSTAGRAM</h2> <div class="w-full" data-is="module-instagram"></div> <div class="h128"></div> </div> </div> </div> <div data-is="module-footer"></div> </div> <div class="fixed t0 l0 b0" data-is="module-sidebar"></div>', 'page-index,[data-is="page-index"]{display:block} page-index .animation-shake-y,[data-is="page-index"] .animation-shake-y{animation-duration:2s}', '', function(opts) {
    this.title = 'YOH UENO OFFICIAL';

    this.videoSrc = 'https://firebasestorage.googleapis.com/v0/b/yoh-ueno.appspot.com/o/TOP%2FTOP%20(1).mp4?alt=media&token=929cd41e-3597-4103-8e19-f84f26408ed7';

    this.preload = async ({req, res}) => {

      var lessons = await fetch(`${spat.config.cms.APIURL}/lessons`, {
        headers: {
          "X-API-KEY": spat.config.cms.APIKey
        },
      }).then(res => res.json()).then(res => {
        return res.contents;
      });

      return {

        lessons,
      };
    };

    this.head = () => {
      return {
        title: 'トップページ',
      };
    };

    this.on('mount', () => {
      var $video = this.refs.video;
      $video.addEventListener('canplay', () => {
        $video.play();
      });
    });

    this.on('show', () => {
      window.addEventListener('scroll', this.scrollDisappear);

      window.requestAnimationFrame(() => {
        app.utils.observeAnimationElement(this.root);
        this.update();
      });
    });

    this.on('unmount', () => {
      window.removeEventListener('scroll', this.scrollDisappear);
    });

    this.scrollDisappear = () => {
      var y = window.scrollY;
      var height = window.innerHeight / 4;
      if (y > height) {
        this.refs.scroll.classList.remove('opacity-100');
        this.refs.scroll.classList.add('opacity-0');
      }
      else {
        this.refs.scroll.classList.remove('opacity-0');
        this.refs.scroll.classList.add('opacity-100');
      }
    };

    this.scrollToContents = () => {
      var target = this.refs.contents;
      target.scrollIntoView({behavior: 'smooth'});
    };
});